import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import { EdwardColors } from 'enums';

interface ColorProps {
  code: string; //possible values: 'XX' | 'BT'
}

// TODO: check if BT used
export const colors = {
  bt: {
    black: '#000',
    dark: '#384a95',
    light: '#6faddb',
    lighter: '#d7edff',

    short: '#8DB4E2',
    mid: '#0084FF',
    long: '#0032CC',
    sliderBgr: '#6faddb',
  },
  test: {
    dark: '#000',
    light: '#000',
    lighter: '#efefef',

    short: EdwardColors.LIGHTER,
    mid: EdwardColors.DARK,
    long: EdwardColors.SECONDARY,
    short_alt: EdwardColors.GRAY_LIGHT,
    mid_alt: EdwardColors.GRAY_LIGHTER,
    long_alt: EdwardColors.GRAY_MEDIUM,
    sliderBgr: '#999',
  },
};

export const colorOpacity = {
  bt: {
    short: 0.85,
    mid: 0.8,
    long: 0.85
  },
  test: {
    short: 0.85,
    mid: 0.8,
    long: 0.85
   }
};

const useColorStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: (props: ColorProps) => ({
      '& .colorLight': {
        color: props.code === 'BT' ? colors.bt.light : colors.test.light,
      },
      '& .bgrLight': {
        backgroundColor: props.code === 'BT' ? colors.bt.light : colors.test.light,
      },
      '& .colorDark': {
        color: props?.code === 'BT' ? colors.bt.dark : colors.test.dark,
      },
      '& .bgrDark': {
        backgroundColor: props.code === 'BT' ? colors.bt.dark : colors.test.dark,
        '&.disabled': { backgroundColor: '#999' }
      },
      '& .bgrLighter': {
        backgroundColor: props.code === 'BT' ? colors.bt.lighter : colors.test.lighter,
      },
      '& h1.shortTerm, & h2.shortTerm, & h2.short_term': {
        color: props?.code === 'BT' ? colors.bt.black : colors.test.dark,
        backgroundColor: props.code === 'BT' ? colors.bt.lighter : colors.test.lighter,
        borderBottomColor: colors.test.short,
      },
      '& h1.midTerm, & h2.midTerm, & h2.mid_term': {
        color: props?.code === 'BT' ? colors.bt.black : colors.test.dark,
        backgroundColor: props.code === 'BT' ? colors.bt.lighter : colors.test.lighter,
        borderBottomColor: colors.test.mid,
      },
      '& h1.longTerm, & h2.longTerm, & h2.long_term, & h2.default': {
        color: props?.code === 'BT' ? colors.bt.black : colors.test.dark,
        backgroundColor: props.code === 'BT' ? colors.bt.lighter : colors.test.lighter,
        borderBottomColor: colors.test.long,
      },
      '& .sliderBgr': {
        backgroundColor: props.code === 'BT' ? colors.bt.sliderBgr : colors.test.sliderBgr,
        '&.disabled': { backgroundColor: '#999' }
      },
    }),
  }),
);

export default useColorStyles;
